<template>
  <div class="view-image-container">
    <el-dialog
      :visible.sync="visible"
      :width="dialogWidth"
      :show-close="true"
      custom-class="image-viewer-dialog"
      @close="close"
      center
    >
      <div class="image-wrapper">
        <img
          v-if="currentImage"
          :src="currentImage.url"
          :style="{
            maxWidth: '100%',
            maxHeight: imageInfo.maxHeight + 'px'
          }"
          @error="handleImageError"
        />
        <div v-if="imageList.length > 1" class="image-nav">
          <span class="nav-btn prev" @click="prevImage" :class="{ disabled: currentIndex <= 0 }">
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="image-counter">{{ currentIndex + 1 }} / {{ imageList.length }}</span>
          <span class="nav-btn next" @click="nextImage" :class="{ disabled: currentIndex >= imageList.length - 1 }">
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ViewImage',
  data() {
    return {
      visible: false,
      dialogWidth: '50%',
      imageList: [],
      currentIndex: 0,
      imageInfo: {
        url: '',
        maxHeight: 600
      }
    }
  },
  computed: {
    currentImage() {
      return this.imageList[this.currentIndex] || null
    }
  },
  methods: {
    open(params, index = 0) {
      if (Array.isArray(params)) {
        this.imageList = params
        this.currentIndex = Math.min(index, params.length - 1)
      } else {
        this.imageList = [params]
        this.currentIndex = 0
      }
      this.visible = true

      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        this.dialogWidth = '90%'
        this.imageInfo.maxHeight = 400
      } else if (screenWidth < 1200) {
        this.dialogWidth = '70%'
        this.imageInfo.maxHeight = 500
      } else {
        this.dialogWidth = '50%'
        this.imageInfo.maxHeight = 600
      }
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    nextImage() {
      if (this.currentIndex < this.imageList.length - 1) {
        this.currentIndex++
      }
    },
    close() {
      this.visible = false
      this.imageList = []
      this.currentIndex = 0
      this.imageInfo = {
        url: '',
        maxHeight: 600
      }
    },
    handleImageError(e) {
      e.target.src = '/img/noPhoto.jpg'
    }
  }
}
</script>

<style lang="scss" scoped>
.view-image-container {
  ::v-deep .image-viewer-dialog {
    .el-dialog__header {
      padding: 10px;
    }

    .el-dialog__body {
      padding: 20px;
      text-align: center;
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 200px;

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        object-fit: contain;
        border-radius: 4px;
      }

      .image-nav {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        gap: 20px;

        .nav-btn {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #409eff;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.3s;

          &:hover:not(.disabled) {
            background: #66b1ff;
            transform: scale(1.1);
          }

          &.disabled {
            background: #c0c4cc;
            cursor: not-allowed;
          }
        }

        .image-counter {
          font-size: 14px;
          color: #606266;
          min-width: 60px;
          text-align: center;
        }
      }
    }
  }
}
</style>
